export const features = [
  {
    icon: 'ri-radar-line',
    title: '实时访客监控',
    desc: '每秒刷新在线访客，实时掌握谁在浏览你的网站，第一时间发现流量高峰与异常波动。',
  },
  {
    icon: 'ri-links-line',
    title: '来源渠道分析',
    desc: '清晰拆解搜索引擎、直接访问、外链与社交媒体的流量占比，知道客户从哪里来。',
  },
  {
    icon: 'ri-file-chart-line',
    title: '页面热度排行',
    desc: '统计每个页面的浏览量、停留时长与跳出率，找出最受欢迎的内容，优化转化路径。',
  },
  {
    icon: 'ri-map-pin-2-line',
    title: '地域与运营商',
    desc: '按省份、城市和网络运营商拆解访客来源，洞察目标市场分布，指导内容与投放策略。',
  },
  {
    icon: 'ri-keyboard-line',
    title: '搜索词与蜘蛛统计',
    desc: '提取百度、360、搜狗带来的真实搜索词，并单独统计搜索引擎蜘蛛抓取，方便做 SEO。',
  },
  {
    icon: 'ri-layout-grid-line',
    title: '多站点统一管理',
    desc: '一个账号管理所有网站，切换自如，数据互不干扰，适合多站点运营的站长与团队。',
  },
];

export const steps = [
  {
    step: '01',
    title: '免费注册账号',
    desc: '30 秒完成注册，无需绑定支付方式，立即开启你的流量统计之旅。',
    icon: 'ri-user-add-line',
  },
  {
    step: '02',
    title: '添加站点获取代码',
    desc: '填写网站名称与域名，一键生成专属的统计埋点代码。',
    icon: 'ri-code-box-line',
  },
  {
    step: '03',
    title: '粘贴代码查看数据',
    desc: '把代码贴到网站页面底部，回到后台即可查看实时访客与完整分析报表。',
    icon: 'ri-line-chart-line',
  },
];

export const pricingPlans = [
  {
    name: '免费版',
    price: '0',
    period: '永久免费',
    desc: '适合个人博客与初创站点，快速上手体验核心统计。',
    features: ['1 个站点', '基础访问统计', '7 天数据保留', '实时访客列表'],
    highlight: false,
    cta: '免费开始',
  },
  {
    name: '专业版',
    price: '99',
    period: '/月',
    desc: '适合认真做运营的站长，解锁完整分析与数据洞察。',
    features: ['10 个站点', '完整来源与页面分析', '90 天数据保留', '地域分布地图', '自定义报表导出'],
    highlight: true,
    cta: '立即升级',
  },
  {
    name: '企业版',
    price: '399',
    period: '/月',
    desc: '适合多站点团队与代理机构，专属支持与高级能力。',
    features: ['不限站点', '无限数据保留', '团队协作与权限', 'API 数据接口', '专属技术支持'],
    highlight: false,
    cta: '联系我们',
  },
];

export const trendData = [
  { label: '周一', value: 1240 },
  { label: '周二', value: 1820 },
  { label: '周三', value: 1560 },
  { label: '周四', value: 2280 },
  { label: '周五', value: 2640 },
  { label: '周六', value: 2410 },
  { label: '周日', value: 3280 },
];

export const sourcesData = [
  { label: '直接访问', value: 42, color: 'bg-primary-500' },
  { label: '搜索引擎', value: 31, color: 'bg-accent-500' },
  { label: '社交媒体', value: 16, color: 'bg-secondary-500' },
  { label: '外部链接', value: 11, color: 'bg-foreground-300' },
];

export const topPages = [
  { title: '/ 首页', views: 12860, rate: '98%' },
  { title: '/blog/seo-guide', views: 8420, rate: '64%' },
  { title: '/product/pricing', views: 5310, rate: '40%' },
  { title: '/about/team', views: 2840, rate: '22%' },
];

export const geoData = [
  { region: '北京', value: 86 },
  { region: '上海', value: 74 },
  { region: '广东', value: 68 },
  { region: '浙江', value: 52 },
  { region: '江苏', value: 47 },
  { region: '四川', value: 33 },
];

export const realtimeVisitors = [
  { ip: '113.88.45.21', region: '北京', page: '/ 首页', time: '刚刚', device: 'ri-smartphone-line' },
  { ip: '183.14.102.8', region: '广东 深圳', page: '/blog/seo-guide', time: '12 秒前', device: 'ri-computer-line' },
  { ip: '58.246.19.73', region: '上海', page: '/product/pricing', time: '25 秒前', device: 'ri-computer-line' },
  { ip: '120.229.88.41', region: '浙江 杭州', page: '/ 首页', time: '38 秒前', device: 'ri-smartphone-line' },
];